module.exports = __webpack_public_path__ + "static/hood-logo-ba5f1f9504227dd3ab7f09a5d2fd127b.png";